interface Plotly {
  newPlot: (
    el: HTMLElement,
    data: { [key: string]: unknown }[],
    layout?: { [key: string]: unknown },
    extraConfig?: unknown
  ) => Promise<boolean>;
  react: (
    el: HTMLElement,
    data: { [key: string]: unknown }[],
    layout?: { [key: string]: unknown },
    extraConfig?: unknown
  ) => Promise<boolean>;
  Plots: {
    resize: (el: HTMLElement) => void;
  };
}

declare global {
  interface Window {
    __rendering?: {
      prism?: {
        ready: boolean;
        loading: boolean;
        load: () => Promise<unknown>;
        render: (container: HTMLElement | string) => void;
      };
      mathJax?: {
        ready: boolean;
        loading: boolean;
        load: () => Promise<unknown>;
        render: (container: HTMLElement | string) => void;
      };
      plotly?: {
        ready: boolean;
        loading: boolean;
        Plotly: Plotly | null;
        load: () => Promise<unknown>;
        renderElement: (el: HTMLElement) => void;
        renderAll: (container: HTMLElement | string) => void;
      };
    };
    Prism?: {
      manual: boolean;
      highlightAllUnder: (
        container: HTMLElement,
        async?: boolean,
        callback?: (element: HTMLElement) => void
      ) => void;
    };
    MathJax?: {
      typesetPromise?: (
        elements?: string[] | HTMLElement[]
      ) => Promise<unknown>;
      tex?: {
        inlineMath?: [string[], string[]] | [];
        displayMath?: [string[], string[]] | [];
      };
      output?: {
        displayAlign?: string;
        displayIndent?: string;
      };
      svg?: {
        fontCache?: string;
        scale?: number;
        minScale?: number;
        mtextInheritFont?: boolean;
        exFactor?: number;
      };
      startup?: {
        typeset?: boolean;
      };
      options?: {
        skipHtmlTags?: string[];
        processHtmlClass?: string;
        ignoreHtmlClass?: string;
      };
    };
    Plotly: Plotly | null;
  }
}

window.__rendering ??= {};
